import { loadStripe } from "@stripe/stripe-js";

export const stripePromise = loadStripe(
  "pk_live_51SVMTKQ4vhKt5Aq2ONp8Cjeua31ZjSQHHmOFD0p7sVPwVr5UDNNhGgldcWXCx31E4Ma7QeH0RI7MWA5AIxEty6Y9009maiq6Me"
);
